<template>
    <div>
        <div class="row" :class="{'mb-4': !$loadModule('treatments')}">
            <div class="col-12 col-md mb-4 mb-md-0 text-center text-md-left">
                <button class="btn btn-white mr-3" v-if="$loadModule('treatments')" @click="elementaryModal">{{$t('Initial examination')}}</button>
                <permission-check resource="text-templates" create v-if="$loadModule('textTreatments')">
                    <button class="btn btn-white" @click.stop="openExamDescModal({})">{{$t('Describe treatment')}}</button>
                </permission-check>
            </div>
            <div class="col-12 col-md-auto d-flex align-items-center justify-content-center justify-content-lg-end" v-if="$loadModule('treatments')">
                <custom-switch v-model="kid" :title="$t('Baby map') " id="kidOrNot" class="m-0 p-0" />
            </div>
        </div>
        <div class="row" v-if="$loadModule('treatments')">
            <div class="col">
                <image-map class="mb-4" :kid="kid" :state="teethState" :tooths="byToothNumber"></image-map>
                <!-- <tooth-map class="mb-4" :tooths="tooths"></tooth-map> -->
            </div>
        </div>
        <div class="card" v-if="sortedItems.length>0 && $loadModule('treatments')">
            <div class="card-body p-3">
                <div class="row">
                    <div class="col"></div>
                    <div class="col-auto">
                        <b-button-group>
                            <b-button :variant="group=='date' ? 'primary' : 'white'" @click="group='date'">{{$t('By date')}}</b-button>
                            <b-button :variant="group=='teeth' ? 'primary' : 'white'" @click="group='teeth'">{{$t('By tooth')}}</b-button>
                        </b-button-group>
                    </div>
                </div>
            </div>
        </div>

        <div class="card" v-for="tooth in sortedItems" :key="tooth.number">
            <div class="card-body hover pointer" @click="view(tooth.number)">
                <div class="row align-items-top">
                    <div class="col-auto text-center p-0" style="width: 50px;">
                        <h2 v-if="group=='teeth' && tooth.number">{{tooth.number}}</h2>
                    </div>
                    <div class="col">
                        <div class="row mb-4" v-for="(exam, trIndex) in tooth.exams" :key="trIndex">
                            <div class="col-auto" style="width: 180px;">
                                <div v-if="(group=='date' && trIndex==0) || group=='teeth'">{{ exam.createdAt | moment('MMMM Do YYYY') }}</div>
                                <span class="small text-muted">{{ exam.user.firstName }} {{exam.user.lastName}}</span>
                            </div>
                            <div class="col-auto col-md-auto text-center h2" v-if="group=='date'">{{exam.tooth}}</div>
                            <div class="col col-md-auto text-center small mb-2" style="width: 100px;">
                                <tooth-parts
                                    class="d-flex justify-content-center"
                                    readonly="true"
                                    width="40"
                                    :tooth="exam.tooth"
                                    v-model="exam.parts"
                                ></tooth-parts>
                            </div>
                            <div class="col-12 col-md">
                                <div class="card mb-1" v-if="exam.description" @click.stop="openExamDescModal(exam)">
                                    <div class="card-body p-3 text-muted small">
                                        <div>{{exam.description| annotation}}</div>
                                    </div>
                                </div>
                                <div class="card mb-1" v-for="(service, index) in exam.treatments" :key="index">
                                    <div class="card-body p-3" :class="{'text-muted':service.done}">
                                        <div class="row align-items-center">
                                            <div class="col">
                                                <strong>{{service.code}}</strong>
                                                - {{ service.label}}
                                                <div class="row">
                                                    <span class="col-auto text-muted small m-0">{{service.duration}} {{$t('min')}}</span>
                                                    <span class="col-auto text-muted small m-0">
                                                        <money class="m-0" :value="service.price"></money>
                                                    </span>
                                                    <div class="col-auto">
                                                        <span class="badge badge-success" v-if="service.done">{{$t('Done')}}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <single-tooth id="SingleToothModal" :customerId="$route.params.id"></single-tooth>
        <exam-modal id="examModal"></exam-modal>
        <elementary-modal id="ElementaryModal" :customerId="$route.params.id"></elementary-modal>

        <exam-description-modal id="examDescription"></exam-description-modal>
    </div>
</template>

<script>
import debounce from 'lodash/debounce';
import orderBy from 'lodash/orderBy';
import Avatar from '@/components/Avatar'
import SingleTooth from '@/components/Tooth/Single'
import CardLoading from '@/components/CardLoading';
import DateFilter from '@/components/DateFilter';
import { modalMixins } from '@/mixins/modal.js'
import { mapActions, mapGetters, mapState } from 'vuex';
import ToothMap from '@/components/ToothMap';
import ImageMap from '@/components/Teeth/Map';
import ToothParts from '@/components/Tooth/Parts';
import SimpleTable from '@/components/SimpleTable'
import ExamModal from '@/Pages/People/Customer/ExamModal.vue';
import CustomSwitch from '@/components/CustomSwitch';

import ElementaryModal from '@/Pages/People/Customer/ElementaryExam';
import Money from '@/components/Money';

import ExamDescriptionModal from "./ExamDescriptionModal";

export default {
    props: ['id'],
    mixins: [modalMixins],
    components: {
        CustomSwitch,
        Money,
        ImageMap,
        Avatar,
        ToothMap,
        ExamModal,
        DateFilter,
        ToothParts,
        CardLoading,
        SimpleTable,
        SingleTooth,
        ElementaryModal,
        ExamDescriptionModal
    },
    data() {
        return {
            group: 'teeth',
            kid: true,
            query: null,
            staffQuery: [],
            dates: {},
            filter: 'upcoming',
            xrayDefaults: {
                customerId: this.$route.params.id,
            },
            fileData: {
                customerId: this.$route.params.id,
            },
            params: {

                query: {
                    $limit: 1000,
                    customerId: this.$route.params.id,
                    $sort: {
                        createdAt: -1
                    }
                }
            },
            columns: [
                {
                    label: 'Tooth',
                    name: 'tooth',
                    sortable: true,
                    width: '5'
                },
                {
                    label: 'Diagnosis',
                    name: 'icd',
                    field(row) {
                        return row;
                    }

                },
                {
                    label: 'Date',
                    name: 'createdAt',
                    sortable: true,
                    duration: true,
                    date_format: 'MMMM D, YYYY'
                },


            ],
        }
    },
    computed: {
        ...mapState('exam', { areDataLoading: 'isFindPending' }),
        ...mapGetters('my-team', { findTeamInStore: 'find', user: 'get' }),
        ...mapGetters('exam', { findDataInStore: 'find' }),
        ...mapGetters('customers', { getCustomer: 'get' }),
        ...mapGetters('configurator', { findConfsInStore: 'find' }),

        treatmentPlan() {
            let optionIds = []
            let result = [];
            this.customer.elementaryExam.map.filter(el => el.options).forEach(el => optionIds.push(...el.options))
            this.findConfsInStore({ query: { 'options._id': { $in: optionIds } } }).data.forEach(el => result.push(...el.options))
            return result
        },

        teethState() {
            if (this.customer.elementaryExam) {
                return this.customer.elementaryExam.map;
            } else {
                return [];
            }
        },

        customer() {
            return this.getCustomer(this.customerId);
        },
        age() {
            return this.$moment().diff(this.customer.birth_date, 'years');
        },

        byToothNumber() {
            let grouped = {};
            let items = this.findDataInStore(this.params).data;
            items.map(item => {
                grouped[item.tooth] = grouped[item.tooth] || { number: item.tooth, state: [], treatment: true };
                // grouped[item.tooth].exams.push(item);
            });

            this.customer.elementaryExam.map.map(item => {
                grouped[item.tooth] = grouped[item.tooth] || { number: item.tooth, state: [] };
                grouped[item.tooth].state.push(item.diagnosis);
            });

            return grouped;
        },
        tooths() {

            let items = this.findDataInStore(this.params).data;

            let grouped = {};
            if (this.group == 'date') {
                items.forEach(item => {
                    let key = this.$moment(item.createdAt).format();
                    grouped[key] = grouped[key] || { number: item.tooth, exams: [], lastDate: item.createdAt };
                    grouped[key].exams.push(item);
                })
            } else {
                items.forEach(item => {

                    grouped[item.tooth] = grouped[item.tooth] || {
                        number: item.tooth,
                        exams: [],
                        lastDate: item.createdAt
                    };
                    grouped[item.tooth].exams.push(item);
                })
            }


            // items.map(item => {
            //     // item.user = this.user(item.userId);
            // });
            return grouped;
        },

        sortedItems() {
            let tooths = Object.values(this.tooths);

            return orderBy(tooths, ['lastDate', 'number'], 'desc');
        },

        staff() {
            return this.findTeamInStore().data;
        },

        customerId() {
            return this.$parent.customer._id;
        }
    },
    created() {
        this.kid = (this.age > 0 && this.age <= 7);
        this.fetchData();
        this.fetchConfs();
        // this.fetchTeam();

    },
    filters: {
        annotation: function (string) {
            const div = document.createElement('div')
            div.innerHTML = string
            string = div.textContent || div.innerText || ''
            return string.substring(0, 250) + '...';
        }
    },
    watch: {
        group: debounce(function (newVal) {
            console.log('group', newVal);

        }, 300),
        dates: debounce(function (newVal) {
            if (newVal.start) {
                this.params.query.xrayAt = {
                    $gte: newVal.start,
                    $lte: newVal.end
                }
            } else {
                delete this.params.query.xrayAt;
            }
            this.fetchData();
        }, 400),

        query: debounce(function (newVal) {
            if (newVal) {
                this.params.query.$or = [
                    { notes: { $regex: newVal, $options: "i" } },
                    { label: { $regex: newVal, $options: "i" } },
                ];
            } else {
                delete this.params.query.$or;
            }

            this.fetchData();
        }, 400),

        /* Find by staf  */
        staffQuery: debounce(function (newVal) {
            if (newVal.length <= 0) {
                delete this.params.query.services;
            } else {
                this.params.query.services = { userId: { $in: newVal } };
            }
            this.fetchData();
        }, 400),
    },
    methods: {
        ...mapActions('exam', ['find']),
        ...mapActions('configurator', { fetchConfs: 'find' }),

        elementaryModal() {
            this.openModal({
                id: 'ElementaryModal',
            })
        },
        view(tooth) {

            //if (!tooth) return;
            let toothItem = {
                tooth,
                _id: 'temp'
            };
            const { Treatment } = this.$FeathersVuex;
            new Treatment(toothItem);

            this.openModal({
                id: 'SingleToothModal',
                tooth: tooth,
            })
        },
        edit(item) {
            this.openModal({
                id: 'XrayModal',
                model: item
            })
        },

        fetchData() {
            this.find(this.params);
        },
        use(image) {
            this.$root.$emit('bv::hide::modal', this.id);
            this.action(image);
        },
        save() {
            this.errors = null;
            this.hideForm = true;
        },
        deleteItem(item) {
            this.remove(item._id).then(result => {
                this.$toasted.global.success({
                    message: this.$t('Item has been deleted')
                });
            });
        },
        openExamDescModal(exam) {
            let examItem = {
                exam,
                _id: 'temp'
            };
            const { Exam } = this.$FeathersVuex;
            new Exam(examItem);

            this.openModal({
                id: 'examDescription',
                data: exam,
            })
        }

    },


}
</script>

<style lang="scss" scoped>
</style>
